import React from 'react';
import TextField from '@material-ui/core/TextField';

const FormDate = ({label, label_exclaim, name, error, touched, onChange, onBlur, autoComplete, ...props}) => (
    <TextField
        id={name}
        name={name}
        label={label}
        onChange={onChange}
        onBlur={onBlur}
        error={touched && !!error}
        helperText={(touched && error) || label_exclaim}
        autoComplete={autoComplete ? autoComplete : 'off'}
        InputLabelProps={{
            shrink: true,
        }}
        {...props}
    />
);

FormDate.defaultProps = {
    fullWidth: false,
};

export default FormDate;


// WEBPACK FOOTER //
// ./resources/assets/js/components/Form/FormDate.js